import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { logOut } from "Apis/signIn";
import { useNavigate } from "react-router-dom";
import { getAccessByModuleName } from "routes";
import { AuthRouteJson } from "helpers/constant";
import Swal from "sweetalert2";
import { encryptValues } from "helpers/cryptography";
import { decryptData } from "helpers/cryptography";

export const LoginFormContext = createContext();
const LoginContext = ({ children }) => {
  const [profileImage, setProfileImage] = useState("");
  const [profile, setProfile] = useState("");
  const [memberEditData, setMemberEditData] = useState([]);
  const [postEditData, setPostEditData] = useState([]);
  const [profileName, setProfileName] = useState("");

  const [notification, setNotification] = useState({
    color: "success",
    icon: "check",
    title: "Material Dashboard",
    content: "Hello, world! This is a notification message",
    open: false,
  });
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("isLogin") || false);
  const [modules, setModules] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterLoader, setFilterLoader] = useState(false);

  useEffect(() => {
    const encrypted = localStorage.getItem("modules");
    if (encrypted) {
      const modules = decryptData(encrypted);
      if (modules) setModules(convertPermissionsIntToBoolean(modules));
    }
  }, []);

  const AppLoader = (val, time) => {
    if (val === false) {
      setTimeout(() => {
        setIsLoading(false);
      }, time ?? 1500);
    } else if (val === true) {
      setIsLoading(true);
    } else {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, time ?? 1500);
    }
  };

  const LogIn = (values) => {
    // localStorage.setItem("user_data", JSON.stringify(values));
    localStorage.setItem("authorization", values.token);
    localStorage.setItem("role", encryptValues(values?.role).security_text);
    localStorage.setItem("modules", encryptValues(values?.role?.modules).security_text);
    setIsLoggedIn(true);
    localStorage.setItem("isLogin", true);
    setModules(convertPermissionsIntToBoolean(values.role.modules));
    setIsLoading(false);
  };

  // Convert Permission Value 1/0 in Boolean
  function convertPermissionsIntToBoolean(modules) {
    return modules.map((module) => {
      return {
        ...module,
        permissions: {
          ...module.permissions,
          read_access: Boolean(module.permissions.read_access),
          write_access: Boolean(module.permissions.write_access),
          delete_access: Boolean(module.permissions.delete_access),
        },
      };
    });
  }

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLogin"));
  }, []);

  const [access, setAccess] = useState({});
  const getModuleAccess = (moduleName) => {
    let access = getAccessByModuleName(modules, moduleName);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      setNotification({
        color: "error",
        icon: "error",
        title: "Error",
        content: "You are not authorized to access.",
        open: true,
      });
      window.location.href = AuthRouteJson.dashboard;
    }
  };

  //Handle LogOut Function...
  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want really to logout!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    });
    if (result.isConfirmed) {
      AppLoader(true);
      let response = await logOut();
      if (response?.status === 200) {
        localStorage.removeItem("loginTime");
        localStorage.removeItem("authorization");
        localStorage.removeItem("role");
        localStorage.removeItem("modules");
        localStorage.removeItem("isLogin");
        navigate(AuthRouteJson.signin);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
        AppLoader(false);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response.data.message,
          open: true,
        });
        AppLoader(false);
      }
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [hasUploaded, setHasUploaded] = useState(false);
  const [imageName, setImageName] = useState("");

  return (
    <LoginFormContext.Provider
      value={{
        notification,
        setNotification,
        handleLogout,
        profileImage,
        setProfileImage,
        memberEditData,
        setMemberEditData,
        postEditData,
        setPostEditData,
        LogIn,
        isLoggedIn,
        setIsLoggedIn,
        modules,
        setModules,
        access,
        setAccess,
        getModuleAccess,
        isLoading,
        setIsLoading,
        filterLoader,
        setFilterLoader,
        AppLoader,
        imageName,
        setImageName,
        hasUploaded,
        setHasUploaded,
        selectedFile,
        setSelectedFile,
        profileName,
        setProfileName,
        profile,
        setProfile,
      }}
    >
      {children}
    </LoginFormContext.Provider>
  );
};
LoginContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoginContext;
